import { systems } from "@inter-ikea-storagetwo/range";
import { AlignmentConnectionCreationSystem } from "@inter-ikea-core/core";
import AutoAdaptChildrenAfterSectionResizeSystem from "./AutoAdaptChildrenAfterSectionResizeSystem";
import InteractiveBoaxelSectionSystem from "./InteractiveBoaxelSectionSystem";
import AddDraggableToRootMountingRailSystem from "./AddDraggableToRootMountingRailSystem";
import InteractiveUprightSystem from "./InteractiveUprightSystem";
import RemoveSectionSystem from "./RemoveSectionSystem";
import ToggleCollidersOnUprightDragSystem from "./ToggleCollidersOnUprightDragSystem";
import MergeSectionSystem from "./MergeSectionSystem";
import AddAlignmentToMountingRailSystem from "./AddAlignmentToMountingRailSystem";
import HandleInteractiveBoaxelUndoRedoSystem from "./HandleInteractiveBoaxelUndoRedoSystem";
import AdaptMountingRailBoundingBoxSystem from "./AdaptMountingRailBoundingBoxSystem";
import InteractiveEntitySystem from "./InteractiveEntitySystem";
import AdaptBoaxelAdjustableSystem from "./AdaptBoaxelAdjustableSystem";
import OnAddMountingRailToSceneSystem2 from "./OnAddMountingRailToSceneSystem2";
import ResizeAdjustableSystem from "./ResizeAdjustableSystem";
import UndoRedoListenerSystem from "./UndoRedoListenerSystem";
import AdjustMountingRailModelParentSystem from "./AdjustMountingRailModelParentSystem";
import SectionSelectionSystem from "./SectionSelectionSystem";
import UndoRedoOutlineSystem from "./UndoRedoOutlineSystem";
import DisableColliderSystem from "@inter-ikea-storagetwo/range/dist/systems/DisableColliderSystem";
const { HandleSectionAttachmentSystem, HandleSideUnitRemovalSystem, AttachmentsSystem, RefreshSectionsAlignmentsOnDragSystem, ValidateDragSystem, } = systems;
export const systemsDefinitionList = {
    refreshSectionsAlignmentsOnDragSystem: ({ core }) => new RefreshSectionsAlignmentsOnDragSystem(core.services.entityManager),
    alignmentConnectionCreationSystem: ({ core }) => new AlignmentConnectionCreationSystem(core.services),
    attachmentSystem: ({ core }) => new AttachmentsSystem(core.services.entityManager),
    handleSideUnitRemovalSystem: ({ core }) => new HandleSideUnitRemovalSystem(core.services.productManager, core.services),
    handleSectionAttachmentSystem: ({ core }) => new HandleSectionAttachmentSystem(core.services.productManager),
    validateDragSystem: ({ core }) => new ValidateDragSystem(core.services),
    uprightSystem: ({ core }) => new AutoAdaptChildrenAfterSectionResizeSystem(core),
    InteractiveBoaxelSectionSystem: ({ core }) => new InteractiveBoaxelSectionSystem(core),
    AddDraggableToRootMountingRailSystem: () => new AddDraggableToRootMountingRailSystem(),
    interactiveUprightSystem: ({ core }) => new InteractiveUprightSystem(core),
    RemoveSectionSystem: ({ core }) => new RemoveSectionSystem(core),
    toggleCollidersOnUprightDragSystem: () => new ToggleCollidersOnUprightDragSystem(),
    SnapMountingRailSystem: ({ core }) => new MergeSectionSystem(core),
    AddAlignmentToMountingRailSystem: ({ core }) => new AddAlignmentToMountingRailSystem(core),
    handleInteractiveBoaxelUndoRedoSystem: ({ core }) => new HandleInteractiveBoaxelUndoRedoSystem(core),
    adaptMountingRailBoundingBoxSystem: ({ core }) => new AdaptMountingRailBoundingBoxSystem(core),
    interactiveEntitySystem: ({ core }) => new InteractiveEntitySystem(core),
    adaptAdjustableSystem: () => new AdaptBoaxelAdjustableSystem(),
    onAddMountingRailToSceneSystem: ({ core, viewer }) => new OnAddMountingRailToSceneSystem2(core, viewer),
    ResizeAdjustableSystem: () => new ResizeAdjustableSystem(),
    undoRedoListenerSystem: ({ core, viewer }) => new UndoRedoListenerSystem(core, viewer),
    adjustMountingRailModelParentSystem: ({ core, viewerCoreAdapter }) => new AdjustMountingRailModelParentSystem(core, viewerCoreAdapter),
    sectionSelectionSystem: ({ core }) => new SectionSelectionSystem(core),
    undoRedoOutlineSystem: ({ core }) => new UndoRedoOutlineSystem(core),
    disableColliderSystem: () => new DisableColliderSystem(),
};
